/*eslint-disable*/
import { createRoot } from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { createReduxHistoryContext } from 'redux-first-history';
import { HistoryRouter as Router } from "redux-first-history/rr6/index.js";
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/browser';
import { getUserBySecretKey } from './thunks/userAuthThunks.js';

import AppContainer from './containers/AppContainer.js';
import createRootReducer from './reducers/index.js';
import fetchHelper, { setupInterceptors, setCsrfToken } from './utils/fetchHelper.js';
import '@ant-design/v5-patch-for-react-19';

if (import.meta.env.MODE === 'production') {
    Sentry.init({ dsn: 'https://599cdaaf38684ceaa07888d7354143f0@o378690.ingest.sentry.io/5202487' });
}

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

const store = configureStore({
    reducer: createRootReducer(routerReducer),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: true,
            serializableCheck: false,
        }).concat(routerMiddleware),
    preloadedState: undefined,
    devTools: import.meta.env.MODE !== 'production',
});

const initSecurity = async () => {
    try {
        const res = await fetchHelper.get('/csrf/csrf-token');
        setCsrfToken(res.result.csrfToken);
    } catch (e) {
        console.error('Failed to fetch CSRF token', e);
    }
};

setupInterceptors(store);

const history = createReduxHistory(store);

const root = createRoot(document.getElementById('root'));

initSecurity()
    .finally(() => store.dispatch(getUserBySecretKey()))
    .finally(() => {
        root.render(
            <Provider store={store}>
                <Router history={history}>
                    <AppContainer />
                </Router>
            </Provider>,
        );
});
